export const doubleOCheck = (value: any) => {
    if (value === null) {
        return 'N/A';
    }
    return value.toString() === '37' ? '00' : value.toString();
}